import { handleActions } from 'redux-actions';

export const initialState = {};

const payment = handleActions({}, initialState);

export default payment;



// WEBPACK FOOTER //
// ./src/store/reducers/Payment/index.js